var map = {
	"./mb-bank.svg": 28549,
	"./mb-charge.svg": 26603,
	"./mb-pay.svg": 88099,
	"./mb-seven.svg": 95354,
	"./sv-borrow.svg": 20910,
	"./sv-entry.svg": 1763,
	"./sv-recipe.svg": 94451,
	"./sv-return.svg": 34295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72989;